import { render } from "./style3.vue?vue&type=template&id=f8f65758"
import script from "./style3.vue?vue&type=script&lang=js"
export * from "./style3.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__